export const replaceNewLineWithBreak = (content: string) => {
  return content.replace(/\n/g, '<br>');
};
